import { render, staticRenderFns } from "./CallInfoPopup.vue?vue&type=template&id=5208ab3f"
import script from "./CallInfoPopup.vue?vue&type=script&lang=js"
export * from "./CallInfoPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports